import {api} from '@/utils/api';

let instance = null;

export default () => {
    if (instance) {
        return instance;
    }
    // eslint-disable-next-line no-async-promise-executor
    instance = new Promise(async(resolve) => {
        const staticData = await api.getStaticData();
        const currentYear = new Date().getFullYear();
        const startBirth = currentYear - 60;
        const endBirth = currentYear - 16;
        Object.assign(staticData, {birthList: Array.from({length: endBirth - startBirth + 1}, (v, i) => ({text: startBirth + i, value: startBirth + i}))});

        const map = {
            birthMap: {},
            eduMap: {},
            workMap: {},
            salaryMap: {}
        };

        staticData.birthList.forEach((e) => {
            map.birthMap[e.value] = e.text;
        });
        staticData.educationList.forEach((e) => {
            map.eduMap[e.value] = e.text;
        });
        staticData.workYearList.forEach((e) => {
            map.workMap[e.value] = e.text;
        });
        staticData.salaryList.forEach((e) => {
            map.salaryMap[e.value] = e.text;
        });

        resolve({
            list: staticData,
            map
        });
    });
    return instance;

};

export const privateList = [
    {
        value: 1,
        text: '所有招聘方',
        textTip: '通过营业执照或法人等认证的招聘方'
    },
    {
        value: 0,
        text: '仅我投递的招聘方',
        textTip: '不会出现在简历库中，不会被非投递的招聘方邀约'
    }
];
